import React, { Component } from "react";
import { Checkbox } from "material-ui";
import { Typeahead } from "react-bootstrap-typeahead";
import Tooltip from "react-tooltip-lite";

import map from "lodash/map";
import { getLanguageGroup } from "../../utils/segment_util";
const showCodeTitle = [
  "PRIZM Premier",
  "P$YCLE",
  "P$YCLE Premier",
  "ConneXions",
  "IPA",
  "Net Worth",
];

const showGroupCodeTitle = ["Acculturation", "Language Segments"];
class ValuePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      beSearchedId: undefined,
      focusItemId: undefined,
    };
  }

  handleSearchValueChange(selectedItem, datas) {
    if (selectedItem.length > 0) {
      datas.forEach((item, index) => {
        if (item.id === selectedItem[0].id) {
          this.setState({
            beSearchedId: selectedItem[0].id,
          });
          this.refs.valueList.scrollTop = index * 40;
        }
      });
    }
  }

  showGroupItems(clsName, disabledAll) {
    const { displayData, granularity } = this.props;
    const renderItems = [];

    map(displayData, data => {
      if (data.value.endsWith("1")) {
        renderItems.push(
          <div
            key={"group_" + getLanguageGroup(data.value)}
            style={{
              height: "40px",
              paddingTop: "10px",
              background: "rgb(232, 232, 232)",
              marginLeft: "40px",
              marginBottom: "20px",
              marginRight: "20px",
            }}
          >
            <span style={{ marginLeft: "40px" }}>
              <strong>Code</strong>
            </span>
            <span style={{ marginLeft: "90px" }}>
              <strong>{getLanguageGroup(data.value)}</strong>
            </span>
          </div>,
        );
      }
      renderItems.push(
        <div
          key={data.label + data.id + "_node"}
          style={{ color: "#017FB5", cursor: "pointer" }}
          className={clsName}
          onClick={() => {
            this.setState({
              indexKey: data.id,
            });
          }}
          onMouseOver={() => {
            this.setState({ focusItemId: data.id });
          }}
        >
          <Checkbox
            label={
              <div style={{ display: "flex", paddingLeft: "30px" }}>
                <div style={{ width: "150px" }}>{data.value}</div>
                <div style={{ flexGrow: "1" }}>
                  {data.label}
                  {this.state.focusItemId === data.id && (
                    <span className="ml-10 black-border p-5">
                      {granularity}
                    </span>
                  )}
                </div>
              </div>
            }
            labelStyle={{
              fontSize: "16px",
              background:
                this.state.beSearchedId === data.id ? "#C3C3C3" : "#FFF",
            }}
            iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
            checked={
              this.props.selected_segments.indexOf(data.id) >= 0 || disabledAll
            }
            disabled={disabledAll}
            onCheck={(e, isInputChecked) => {
              this.props.onCheck(data.id, isInputChecked);
            }}
          />
        </div>,
      );
    });
    return renderItems;
  }

  render() {
    let clsName = "mt-10 ml-10 mr-10 p-10";
    const { disabledAll } = this.props;
    return (
      <div
        key={this.props.key + "-value-node-contianer"}
        className="light-grey-border"
      >
        <div className="pt-20 ml-20 mr-20 mb-20 pb-10 light-grey-bottom-border">
          <strong>{this.props.title}</strong>
        </div>
        {this.props.showFilter && (
          <div
            className="ml-20 mr-20 mb-10 pb-15 light-grey-bottom-border"
            style={{ marginTop: "-5px" }}
          >
            <Typeahead
              key="value_panel_search_box"
              labelKey="label"
              multiple={false}
              options={this.props.displayData}
              placeholder={"Search " + this.props.title}
              onChange={selectedItem =>
                this.handleSearchValueChange(
                  selectedItem,
                  this.props.displayData,
                )
              }
            />
          </div>
        )}
        {showCodeTitle.indexOf(this.props.title) >= 0 && (
          <div
            style={{
              height: "40px",
              paddingTop: "10px",
              background: "rgb(232, 232, 232)",
              marginLeft: "40px",
              marginBottom: "20px",
              marginRight: "20px",
            }}
          >
            <span style={{ marginLeft: "20px" }}>
              <strong>Segment</strong>
            </span>
            <span style={{ marginLeft: "100px" }}>
              <strong>Segment Name</strong>
            </span>
          </div>
        )}
        <div
          style={{
            height: this.props.showFilter ? "390px" : "443px",
            overflowY: "scroll",
          }}
          ref={"valueList"}
        >
          {showGroupCodeTitle.indexOf(this.props.title) >= 0
            ? this.showGroupItems(clsName, disabledAll)
            : map(this.props.displayData, data => {
                return (
                  <div
                    key={data.label + data.id + "_node"}
                    style={{ color: "#017FB5", cursor: "pointer" }}
                    className={clsName}
                    onClick={() => {
                      this.setState({
                        indexKey: data.id,
                      });
                    }}
                    onMouseOver={() => {
                      this.setState({ focusItemId: data.id });
                    }}
                  >
                    <Checkbox
                      label={
                        showCodeTitle.indexOf(this.props.title) >= 0 ? (
                          <div style={{ display: "flex", paddingLeft: "30px" }}>
                            <div style={{ width: "150px" }}>{data.value}</div>
                            <div style={{ flexGrow: "1" }}>
                              {data.label}
                              {this.state.focusItemId === data.id &&
                                this.props.granularity && (
                                  <span className="ml-10 black-border p-5">
                                    {this.props.granularity}
                                  </span>
                                )}
                            </div>
                          </div>
                        ) : this.state.focusItemId === data.id &&
                          this.props.granularity ? (
                          [
                            <span key={data.label + "-" + data.id + "-span"}>
                              {data.label}
                            </span>,
                            <span
                              key={data.label + "-" + data.id + "-granularity"}
                              className="ml-10 black-border p-5"
                            >
                              {this.props.granularity}
                            </span>,
                          ]
                        ) : (
                          data.label
                        )
                      }
                      labelStyle={{
                        fontSize: "16px",
                        background:
                          this.state.beSearchedId === data.id
                            ? "#C3C3C3"
                            : "#FFF",
                      }}
                      iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                      checked={
                        this.props.selected_segments.indexOf(data.id) >= 0 ||
                        disabledAll
                      }
                      disabled={disabledAll}
                      onCheck={(e, isInputChecked) => {
                        this.props.onCheck(data.id, isInputChecked);
                      }}
                    />
                  </div>
                );
              })}
        </div>
      </div>
    );
  }
}

export default ValuePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/ValuePanel.js